export const getSelectedRetailerId = (state) =>
  state.assignRetailerAccountModal.selectedRetailerId
export const getRetailerContactEmail = (state) =>
  state.assignRetailerAccountModal.retailerContactEmail
export const getRetailerIds = (state) =>
  state.assignRetailerAccountModal.retailerIds
export const getRetailerSearchText = (state) =>
  state.assignRetailerAccountModal.retailerSearchText
